import { createAction } from 'redux-actions';

const hotelActions = {
  FETCH_HOTEL_LIST: 'FETCH_HOTEL_LIST',
  FETCH_HOTEL_LIST_V2: 'FETCH_HOTEL_LIST_V2',
  FETCH_HOTEL_LIST_COMPLETED: 'FETCH_HOTEL_LIST_COMPLETED',
  FETCH_HOTEL_LIST_FAILED: 'FETCH_HOTEL_LIST_FAILED',
  HOTEL_LIST_VISIBLE: 'HOTEL_LIST_VISIBLE',
  SORT_HOTEL_LIST: 'SORT_HOTEL_LIST',
  CLEAR_HOTEL_LIST: 'CLEAR_HOTEL_LIST',
  FETCH_HOTEL_DETAIL: 'FETCH_HOTEL_DETAIL',
  FETCH_HOTEL_DETAIL_COMPLETED: 'FETCH_HOTEL_DETAIL_COMPLETED',
  FETCH_HOTEL_DETAIL_FAILED: 'FETCH_HOTEL_DETAIL_FAILED',
  CLEAR_HOTEL_DETAIL: 'CLEAR_HOTEL_DETAIL',
  FETCH_HOTEL_ROOMS: 'FETCH_HOTEL_ROOMS',
  FETCH_HOTEL_ROOMS_COMPLETED: 'FETCH_HOTEL_ROOMS_COMPLETED',
  FETCH_HOTEL_ROOMS_FAILED: 'FETCH_HOTEL_ROOMS_FAILED',
  CLEAR_HOTEL_ROOMS: 'CLEAR_HOTEL_ROOMS',
  CHECKOUT_HOTEL_BOOKING: 'CHECKOUT_HOTEL_BOOKING',
  CANCEL_CHECKOUT_HOTEL_BOOKING: 'CANCEL_CHECKOUT_HOTEL_BOOKING',
  CHECKOUT_HOTEL_BOOKING_COMPLETED: 'CHECKOUT_HOTEL_BOOKING_COMPLETED',
  CHECKOUT_HOTEL_BOOKING_FAILED: 'CHECKOUT_HOTEL_BOOKING_FAILED',
  CLEAR_HOTEL_CHECKOUT_URL: 'CLEAR_HOTEL_CHECKOUT_URL',
  FETCH_LOCATION_NAME_FROM_ID: 'FETCH_LOCATION_NAME_FROM_ID',
  FETCH_SPECIAL_REQUEST: 'FETCH_SPECIAL_REQUEST',
  FETCH_SPECIAL_REQUEST_COMPLETED: 'FETCH_SPECIAL_REQUEST_COMPLETED',
  FETCH_HOTEL_PRE_CHECKOUT: 'FETCH_HOTEL_PRE_CHECKOUT',
  FETCH_HOTEL_PRE_CHECKOUT_COMPLETED: 'FETCH_HOTEL_PRE_CHECKOUT_COMPLETED',
  FETCH_HOTEL_PRE_CHECKOUT_FAILED: 'FETCH_HOTEL_PRE_CHECKOUT_FAILED',
  FETCH_HOTEL_GUEST_REVIEW: 'FETCH_HOTEL_GUEST_REVIEW',
  FETCH_HOTEL_GUEST_REVIEW_COMPLETED: 'FETCH_HOTEL_GUEST_REVIEW_COMPLETED',
  FETCH_HOTEL_GUEST_REVIEW_FAILED: 'FETCH_HOTEL_GUEST_REVIEW_FAILED',
  FETCH_HOTEL_REFRESH_TOKEN: 'FETCH_HOTEL_REFRESH_TOKEN',
  FETCH_HOTEL_REFRESH_TOKEN_SUCCESS: 'FETCH_HOTEL_REFRESH_TOKEN_SUCCESS',

  // analytics actions
  HOTEL_MOBILE_BACK_BUTTON: 'HOTEL_MOBILE_BACK_BUTTON',
  HOTEL_ITEM_DISCARDED: 'HOTEL_ITEM_DISCARDED',
  HOTEL_LIST_IMPRESSIONS: 'HOTEL_LIST_IMPRESSIONS',
  HOTEL_PRODUCT_CLICK: 'HOTEL_PRODUCT_CLICK',
  HOTEL_EDIT_SEARCH_BUTTON: 'HOTEL_EDIT_SEARCH_BUTTON',
  HOTEL_SHOW_MORE_DESCRIPTION: 'HOTEL_SHOW_MORE_DESCRIPTION',
  HOTEL_SHOW_MORE_POLICY: 'HOTEL_SHOW_MORE_POLICY',
  HOTEL_DETAIL_IMPRESSION: 'HOTEL_DETAIL_IMPRESSION',
  HOTEL_ROOM_IMPRESSION: 'HOTEL_ROOM_IMPRESSION',
  HOTEL_ROOM_VISIBLE: 'HOTEL_ROOM_VISIBLE',
  HOTEL_ROOM_SELECTED: 'HOTEL_ROOM_SELECTED',
  HOTEL_PRODUCT_TO_CHECKOUT: 'HOTEL_PRODUCT_TO_CHECKOUT',

  HOTEL_GUEST_DETAILS_ROOMS_CLICK: 'HOTEL_GUEST_DETAILS_ROOMS_CLICK',
  HOTEL_GUEST_DETAILS_BOOKER_CLICK: 'HOTEL_GUEST_DETAILS_BOOKER_CLICK',
  HOTEL_GUEST_DETAILS_BOOKER_MOBILE_DONE_CLICK:
    'HOTEL_GUEST_DETAILS_BOOKER_MOBILE_DONE_CLICK',
  HOTEL_GUEST_DETAILS_PAGE_LOADED: 'HOTEL_GUEST_DETAILS_PAGE_LOADED',
  HOTEL_GUEST_DETAILS_PROCEED_TO_CHECKOUT:
    'HOTEL_GUEST_DETAILS_PROCEED_TO_CHECKOUT',

  HOTEL_GUEST_DETAILS_API_FAILED: 'HOTEL_GUEST_DETAILS_API_FAILED',
  HOTEL_GUEST_DETAILS_API_FAILED_SEARCH_AGAIN:
    'HOTEL_GUEST_DETAILS_API_FAILED_SEARCH_AGAIN',
  HOTEL_GUEST_DETAILS_PRICE_CHANGED: 'HOTEL_GUEST_DETAILS_PRICE_CHANGED',
  HOTEL_GUEST_DETAILS_PRICE_CHANGED_SELECT_BUTTON:
    'HOTEL_GUEST_DETAILS_PRICE_CHANGED_SELECT_BUTTON',
  HOTEL_GUEST_DETAILS_HOTEL_NOT_AVAILABLE:
    'HOTEL_GUEST_DETAILS_HOTEL_NOT_AVAILABLE',
  HOTEL_GUEST_DETAILS_HOTEL_NOT_AVAILABLE_SEARCH_AGAIN:
    'HOTEL_GUEST_DETAILS_HOTEL_NOT_AVAILABLE_SEARCH_AGAIN',

  HOTEL_GUEST_DETAILS_FORM_FIELDS_ERROR:
    'HOTEL_GUEST_DETAILS_FORM_FIELDS_ERROR',
  HOTEL_GUEST_DETAILS_HAS_MISSING_FIELDS:
    'HOTEL_GUEST_DETAILS_HAS_MISSING_FIELDS',
  HOTEL_BOOKING_CONFIRMATION_LOADED: 'HOTEL_BOOKING_CONFIRMATION_LOADED',
  HOTEL_BOOKING_CONFIRMATION_MANAGE_MY_BOOKING:
    'HOTEL_BOOKING_CONFIRMATION_MANAGE_MY_BOOKING',
  HOTEL_BOOKING_CONFIRMATION_ECOMMERCE: 'HOTEL_BOOKING_CONFIRMATION_ECOMMERCE',
  HOTEL_BOOKING_CONFIRMATION_STATUS: 'HOTEL_BOOKING_CONFIRMATION_STATUS',
  HOTEL_BOOKING_CONFIRMATION_SUCCESS: 'HOTEL_BOOKING_CONFIRMATION_SUCCESS',
  HOTEL_BOOKING_CONFIRMATION_ERROR: 'HOTEL_BOOKING_CONFIRMATION_ERROR',
  HOTEL_BOOKING_DETAILS_ERROR: 'HOTEL_BOOKING_DETAILS_ERROR',
  HOTEL_HIGHLIGHT_FOCUS: 'HOTEL_HIGHLIGHT_FOCUS',
  UPDATE_HOTEL_DETAIL: 'UPDATE_HOTEL_DETAIL',
  HOTEL_TRACKING_SEEONAMAP_WEB: 'HOTEL_TRACKING_SEEONAMAP_WEB',
  HOTEL_TRACKING_SHOWMAP_WEB: 'HOTEL_TRACKING_SHOWMAP_WEB',
  HOTEL_TRACKING_MAP_SELECTAROOM_WEB: 'HOTEL_TRACKING_MAP_SELECTAROOM_WEB',
  TRACK_MAP_VIEW_CLICK: 'TRACK_MAP_VIEW_CLICK',
  HOTEL_LOGIN_MODAL_OPENED: 'HOTEL_LOGIN_MODAL_OPENED',
  ERROR_POP_ROOM: 'ERROR_POP_ROOM',
  HOTEL_DETAILED_REVIEWS: 'HOTEL_DETAILED_REVIEW',
  HOTEL_DETAILED_REVIEWS_PAGINATION: 'HOTEL_DETAILED_REVIEWS_PAGINATION',
  TRACK_HOTEL_ROOM_FILTER: 'TRACK_HOTEL_ROOM_FILTER',
  HOTEL_REVIEWS_CLICK: 'HOTEL_REVIEWS_CLICK',
};

const actionCreators = {
  trackMobileBackButton: createAction(hotelActions.HOTEL_MOBILE_BACK_BUTTON),
  trackHotelDiscarded: createAction(hotelActions.HOTEL_ITEM_DISCARDED),
  trackHotelListVisible: createAction(hotelActions.HOTEL_LIST_VISIBLE),
  trackVisibleHotelRooms: createAction(hotelActions.HOTEL_ROOM_VISIBLE),
  trackHotelCardClick: createAction(hotelActions.HOTEL_PRODUCT_CLICK),
  trackHotelEditSearchClicked: createAction(
    hotelActions.HOTEL_EDIT_SEARCH_BUTTON
  ),
  trackHotelShowMoreDescriptionClicked: createAction(
    hotelActions.HOTEL_SHOW_MORE_DESCRIPTION
  ),
  trackHotelShowMorePolicyClicked: createAction(
    hotelActions.HOTEL_SHOW_MORE_POLICY
  ),
  trackHotelRoomSelected: createAction(hotelActions.HOTEL_ROOM_SELECTED),
  trackProductToCheckout: createAction(hotelActions.HOTEL_PRODUCT_TO_CHECKOUT),
  trackAddToCart: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_PROCEED_TO_CHECKOUT
  ),

  trackGuestDetailsRoomClick: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_ROOMS_CLICK
  ),

  trackGuestDetailsBookerClick: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_BOOKER_CLICK
  ),

  trackGuestDetailsBookerDoneButtonClick: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_BOOKER_MOBILE_DONE_CLICK
  ),

  trackGuestDetailsPageLoaded: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_PAGE_LOADED
  ),

  trackGuestDetailsApiFailed: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_API_FAILED
  ),

  trackGuestDetailsApiFailedSearchAgain: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_API_FAILED_SEARCH_AGAIN
  ),

  trackGuestDetailsPriceChanged: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_PRICE_CHANGED
  ),

  trackGuestDetailsPriceChangedSelectButton: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_PRICE_CHANGED_SELECT_BUTTON
  ),

  trackGuestDetailsHotelNotAvailable: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_HOTEL_NOT_AVAILABLE
  ),
  trackGuestDetailsHotelNotAvailableSearchAgain: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_HOTEL_NOT_AVAILABLE_SEARCH_AGAIN
  ),
  trackGuestDetailsFormFieldError: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_FORM_FIELDS_ERROR
  ),
  trackGuestDetailsHasMissingField: createAction(
    hotelActions.HOTEL_GUEST_DETAILS_HAS_MISSING_FIELDS
  ),
  trackBookingConfirmationLoaded: createAction(
    hotelActions.HOTEL_BOOKING_CONFIRMATION_LOADED
  ),
  trackBookingConfirmationManageMyBooking: createAction(
    hotelActions.HOTEL_BOOKING_CONFIRMATION_MANAGE_MY_BOOKING
  ),
  trackBookingConfirmationEcommerce: createAction(
    hotelActions.HOTEL_BOOKING_CONFIRMATION_ECOMMERCE
  ),
  trackBookingConfirmationStatus: createAction(
    hotelActions.HOTEL_BOOKING_CONFIRMATION_STATUS
  ),
  trackBookingConfirmationSuccessfull: createAction(
    hotelActions.HOTEL_BOOKING_CONFIRMATION_SUCCESS
  ),
  trackBookingConfirmationError: createAction(
    hotelActions.HOTEL_BOOKING_CONFIRMATION_ERROR
  ),
  trackBookingDetailsError: createAction(
    hotelActions.HOTEL_BOOKING_DETAILS_ERROR
  ),
  fetchHotelList: createAction(hotelActions.FETCH_HOTEL_LIST),
  fetchHotelListV2: createAction(hotelActions.FETCH_HOTEL_LIST_V2),
  fetchHotelListCompleted: createAction(
    hotelActions.FETCH_HOTEL_LIST_COMPLETED
  ),
  sortHotelList: createAction(hotelActions.SORT_HOTEL_LIST),
  hotelListImpressions: createAction(hotelActions.HOTEL_LIST_IMPRESSIONS),
  hotelDetailImpression: createAction(hotelActions.HOTEL_DETAIL_IMPRESSION),
  hotelRoomsImpressions: createAction(hotelActions.HOTEL_ROOM_IMPRESSION),
  fetchHotelListFailed: createAction(hotelActions.FETCH_HOTEL_LIST_FAILED),
  clearHotelList: createAction(hotelActions.CLEAR_HOTEL_LIST),
  fetchHotelDetail: createAction(hotelActions.FETCH_HOTEL_DETAIL),
  fetchHotelDetailCompleted: createAction(
    hotelActions.FETCH_HOTEL_DETAIL_COMPLETED
  ),
  fetchHotelDetailFailed: createAction(hotelActions.FETCH_HOTEL_DETAIL_FAILED),
  clearHotelDetail: createAction(hotelActions.CLEAR_HOTEL_DETAIL),
  fetchHotelRooms: createAction(hotelActions.FETCH_HOTEL_ROOMS),
  fetchHotelRoomsCompleted: createAction(
    hotelActions.FETCH_HOTEL_ROOMS_COMPLETED
  ),
  fetchHotelRoomsFailed: createAction(hotelActions.FETCH_HOTEL_ROOMS_FAILED),
  clearHotelRooms: createAction(hotelActions.CLEAR_HOTEL_ROOMS),
  checkoutHotelBooking: createAction(hotelActions.CHECKOUT_HOTEL_BOOKING),
  cancelCheckoutHotelBooking: createAction(
    hotelActions.CANCEL_CHECKOUT_HOTEL_BOOKING
  ),
  checkoutHotelBookingCompleted: createAction(
    hotelActions.CHECKOUT_HOTEL_BOOKING_COMPLETED
  ),
  checkoutHotelBookingFailed: createAction(
    hotelActions.CHECKOUT_HOTEL_BOOKING_FAILED
  ),
  clearHotelCheckoutUrl: createAction(hotelActions.CLEAR_HOTEL_CHECKOUT_URL),
  fetchLocationNameFromId: createAction(
    hotelActions.FETCH_LOCATION_NAME_FROM_ID
  ),
  fetchSpecialRequests: createAction(hotelActions.FETCH_SPECIAL_REQUEST),
  fetchSpecialRequestsCompleted: createAction(
    hotelActions.FETCH_SPECIAL_REQUEST_COMPLETED
  ),
  hotelHighlightFocus: createAction(hotelActions.HOTEL_HIGHLIGHT_FOCUS),
  fetchPreCheckout: createAction(hotelActions.FETCH_HOTEL_PRE_CHECKOUT),
  fetchPreCheckoutCompleted: createAction(
    hotelActions.FETCH_HOTEL_PRE_CHECKOUT_COMPLETED
  ),
  fetchPreCheckoutFailed: createAction(
    hotelActions.FETCH_HOTEL_PRE_CHECKOUT_FAILED
  ),
  fetchRefreshToken: createAction(hotelActions.FETCH_HOTEL_REFRESH_TOKEN),
  fetchRefreshTokenSuccess: createAction(
    hotelActions.FETCH_HOTEL_REFRESH_TOKEN_SUCCESS
  ),
  updateHotelDetail: createAction(hotelActions.UPDATE_HOTEL_DETAIL),
  trackHotelSeeOnAMapWeb: createAction(
    hotelActions.HOTEL_TRACKING_SEEONAMAP_WEB
  ),
  trackHotelShowMapWeb: createAction(hotelActions.HOTEL_TRACKING_SHOWMAP_WEB),
  trackHotelMapSelectARoomWeb: createAction(
    hotelActions.HOTEL_TRACKING_MAP_SELECTAROOM_WEB
  ),
  trackMapViewClick: createAction(hotelActions.TRACK_MAP_VIEW_CLICK),
  trackHotelRoomFilterUse: createAction(hotelActions.TRACK_HOTEL_ROOM_FILTER),
  trackLoginModalOpened: createAction(hotelActions.HOTEL_LOGIN_MODAL_OPENED),
  trackErrorPopOutRoom: createAction(hotelActions.ERROR_POP_ROOM),
  fetchGuestReview: createAction(hotelActions.FETCH_HOTEL_GUEST_REVIEW),
  fetchGuestReviewCompleted: createAction(
    hotelActions.FETCH_HOTEL_GUEST_REVIEW_COMPLETED
  ),
  fetchGuestReviewFailed: createAction(
    hotelActions.FETCH_HOTEL_GUEST_REVIEW_FAILED
  ),
  trackHotelDetailedReview: createAction(hotelActions.HOTEL_DETAILED_REVIEWS),
  trackHotelDetailedReviewPagination: createAction(
    hotelActions.HOTEL_DETAILED_REVIEWS_PAGINATION
  ),
  trackHotelReviewClick: createAction(hotelActions.HOTEL_REVIEWS_CLICK),
};

export { hotelActions as types, actionCreators };
